export const ET_TIMEZONE = "America/New_York";
export const CUTOFF_MINUTES = 13 * 60 + 59;

export const WEEKDAY_NAMES: Record<string, number> = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};
